import { useEffect, useState } from 'react'

import { VariableValue } from '@components/Variables/types'

import { GETVariableDTO } from '@types'

import { EVENT_NAME, subscribe, unsubscribe } from '../../../events'

type Props = {
  instanceId: string
}

export const useLatestFormVariables = (props: Props) => {
  const { instanceId } = props

  const [latestVariables, setLatestVariables] = useState<GETVariableDTO[]>([])

  useEffect(() => {
    const handleChange = (e: CustomEvent<VariableValue>) => {
      setLatestVariables(prevArray => {
        const existingIndex = prevArray.findIndex(v => v.id === e.detail.id)
        const variablesArray = [...prevArray]

        if (existingIndex !== -1) {
          variablesArray[existingIndex] = { ...e.detail, value: e.detail.value }
        } else {
          variablesArray.push({ ...e.detail, value: e.detail.value })
        }

        return variablesArray
      })
    }

    subscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleChange, instanceId)

    return () => unsubscribe(EVENT_NAME.CHANGE_VARIABLE_VALUE, handleChange, instanceId)
  }, [])

  return {
    latestVariables,
  }
}
